var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isError)?_c('img',{staticClass:"custom-el-upload-view-item__image",attrs:{"src":_vm.src,"alt":""},on:{"error":function($event){_vm.isError = true;},"load":function($event){_vm.isError = false;}}}):_c('img',{attrs:{"src":"/assets/images/icon/file/file.png"}})
}
var staticRenderFns = []

export { render, staticRenderFns }